export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Unpaid.a96ef2b4.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};